import { __module as t } from "../../../_virtual/isLatLong.js";
import { a as e } from "./util/assertString.js";
import { m as s } from "./util/merge.js";
!function (t, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = function (t, e) {
    if ((0, d.default)(t), e = (0, a.default)(e, f), !t.includes(",")) return !1;
    var s = t.split(",");
    return !(s[0].startsWith("(") && !s[1].endsWith(")") || s[1].endsWith(")") && !s[0].startsWith("(")) && (e.checkDMS ? n.test(s[0]) && l.test(s[1]) : o.test(s[0]) && u.test(s[1]));
  };
  var d = i(e),
    a = i(s);
  function i(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  var o = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/,
    u = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/,
    n = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i,
    l = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i,
    f = {
      checkDMS: !1
    };
  t.exports = r.default, t.exports.default = r.default;
}(t, t.exports);
var r = t.exports;
export { r as i };